<script setup>
import { ref, computed } from 'vue';
import Modal from '@/Modal.vue';
import Button from '@/components/Button.vue';
import { call } from '../clients/internalClient';
import { inject } from 'vue';
import { db } from '../firestore';
import { doc, onSnapshot } from 'firebase/firestore';
import Payment from './Payment.vue';
import { checkout, redirectToStripePortal } from './paymentActions';
import Icon from '../Icon.vue';
import { renderCreds, renderDate } from './billingUtils';

const userInfo = inject('userInfo');
const billing = inject('billing');
const loading = ref(false);
const emit = defineEmits(['close'])

</script>

<template>
  <Modal title="Your Billing Status" @close="emit('close')">
    <div v-if="!billing">billing isn't enabled for the user</div>
    <div v-else class="content">


      <div class="flex items-center gap-5 pb-4 " @click="placeholdAction">
        <Icon :size="32" name="bi--person-fill-gear"/>
        <div class="flex flex-col items-end">
          <div>{{ userInfo.name }}</div>
          <div>{{ userInfo.email }}</div>        
        </div>
      </div>

      <p v-if="!billing.subscription">
        <div>You currently on <b>Free/Trial</b> plan</div>
        <div><b>{{ renderCreds(billing.credits) }}</b> trail credits left</div>          
      </p>
      <p v-else-if="billing.subscription.status !== 'canceled'">
        <div style="text-decoration: underline; font-weight: bold;">You currently on Pro plan</div>
        <div>Next billing period: {{ renderDate(billing.subscription.billingPeriod) }}</div>
        <div><b>{{ renderCreds(billing.subscription.credits) }}</b><span class="text-xs text-base-content/50">/200</span> monthly credits left</div>
        <div><b>{{ renderCreds(billing.credits) }}</b> add-on credits left</div>          

      </p>
      <p v-else-if="billing.subscription.status === 'canceled'">
        <div style="text-decoration: underline; font-weight: bold;">You have no active subscription</div>
      </p>        
      <div class="btn-section" >
        <Button @action="() => checkout('subscription')" v-if="!billing.subscription || billing.subscription.status === 'canceled'" class="billing-btn" >            
          <Icon :size="30" name="fa6-solid--hand-holding-dollar" />
          <span>Buy Pro Plan</span>              
        </Button>          
        <template v-else>
          <Button @action="() => checkout('credits')" class="billing-btn" >
            <Icon :size="30" name="game-icons--two-coins" />
            <span>Buy Extra Credits</span>
          </Button>      
          <Button @action="redirectToStripePortal()" class="billing-btn">
            <Icon :size="30" name="streamline--subscription-cashflow" />
            <span>Manage Subscription</span>              
          </Button>
        </template>
      </div>

      <a class="link text-sm" href="https://spellapp.com/terms-of-service" target="_blank">terms and conditions</a>
      
    </div>
  </Modal>
  
</template>

<style scoped lang="less">

.content {
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 10px;

}

.billing-btn {
  width: 200px;
  height: 100px;
  display: flex;
  flex-direction: column;
}

.btn-section {
  display: flex;

  gap: 10px;
  flex: 1;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
/* Add any necessary styling here */
</style>
